import { render, staticRenderFns } from "./BannerTemplatesList.vue?vue&type=template&id=92a3995a&lang=pug"
import script from "./BannerTemplatesList.vue?vue&type=script&lang=js"
export * from "./BannerTemplatesList.vue?vue&type=script&lang=js"
import style0 from "./BannerTemplatesList.vue?vue&type=style&index=0&id=92a3995a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports